import { Box, Grid, GridItem, Text, Button } from "@chakra-ui/react";
import React from "react";

export const IncomingShipmentDetails = () => {
  return (
    <Box marginBottom={"6rem"}>
      <Box marginTop="2rem">
        <Text color={"brand.blue"} fontSize="2xl" fontWeight={"800"}>
          Incoming Shipment Details
        </Text>
      </Box>
      <Text color={" #3958DC"} fontSize="sm">
        #1234565
      </Text>

      <Box
        marginTop={"1.5rem"}
        bg={"#52BBFF"}
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        marginLeft="-2rem"
        marginRight={"-2.5rem"}
      >
        Shipment Details
      </Box>
      <Box
        bg="white"
        borderRadius="15px"
        p="2rem"
        mt="2rem"
        boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
      >
        <Box>
          <Grid templateColumns="repeat(2, 1fr)" marginTop={"1rem"}>
            <GridItem colSpan={1}>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                Seller Name
              </Text>
              <Text mt="1rem">Dean Dayal</Text>
            </GridItem>
            <GridItem>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                Product Name
              </Text>
              <Text mt="1rem">Organic Cotton</Text>
            </GridItem>
          </Grid>
        </Box>
        <Box>
          <Grid templateColumns="repeat(4, 1fr)" marginTop={"1rem"}>
            <GridItem>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                Net Weight
              </Text>
              <Text mt="1rem">120 kg</Text>
            </GridItem>
            <GridItem>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                Gross Weight
              </Text>
              <Text mt="1rem">120 kg</Text>
            </GridItem>

            <GridItem>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                Certified Weight
              </Text>
              <Text mt="1rem">103 kg</Text>
            </GridItem>
          </Grid>
        </Box>

        <Box>
          <Grid templateColumns="repeat(4, 1fr)" marginTop={"1rem"}>
            <GridItem>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                Invoice Number
              </Text>
              <Text mt="1rem">INV01345</Text>
            </GridItem>
            <GridItem>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                Invoice Date
              </Text>
              <Text mt="1rem">01/01/23</Text>
            </GridItem>
            <GridItem>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                Invoice
              </Text>
              <Text textDecoration={"underline"} mt="1rem">
                download
              </Text>
            </GridItem>
          </Grid>
        </Box>

        <Box>
          <Text
            color={"brand.blue"}
            fontSize="md"
            fontWeight={"700"}
            marginTop={"1.5rem"}
            marginBottom={"1.5rem"}
          >
            <Box
              as="span"
              borderRight={"3px solid #2272D5"}
              height="40px"
              marginRight={"1rem"}
            ></Box>
            Transaction Certificate Details
          </Text>

          <Grid templateColumns="repeat(2, 1fr)" marginTop={"1rem"}>
            <GridItem colSpan={1}>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                TC Number
              </Text>
              <Text mt="1rem">TC0172543</Text>
            </GridItem>
            <GridItem>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                TC Issue Date
              </Text>
              <Text mt="1rem">06/01/23</Text>
            </GridItem>
          </Grid>
        </Box>

        <Box>
          <Text
            color={"brand.blue"}
            fontSize="md"
            fontWeight={"700"}
            marginTop={"1.5rem"}
            marginBottom={"1.5rem"}
          >
            <Box
              as="span"
              borderRight={"3px solid #2272D5"}
              height="40px"
              marginRight={"1rem"}
            ></Box>
            Cosignee Details
          </Text>
          <Grid templateColumns="repeat(4, 1fr)" marginTop={"1rem"}>
            <GridItem colSpan={1}>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                Name
              </Text>
              <Text mt="1rem">DHL Express</Text>
            </GridItem>
            <GridItem>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                Address
              </Text>
              <Text mt="1rem">Navi Mumbai </Text>
            </GridItem>
            <GridItem>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                Eway Bill
              </Text>
              <Text mt="1rem">EWAY2737393 </Text>
            </GridItem>

            <GridItem>
              <Text color={"brand.blue"} fontSize="md" fontWeight={"700"}>
                Document
              </Text>
              <Text textDecoration={"underline"} mt="1rem">
                download
              </Text>
            </GridItem>
          </Grid>
        </Box>
      </Box>
      <Box>
        <Grid templateColumns="repeat(6, 1fr)" marginTop={"3rem"}>
          <GridItem>
            <Button
              w={"171px"}
              h={"48px"}
              color="brand.white"
              bg="brand.secondaryColor"
              colorScheme="brand.secondaryColor"
              borderRadius={"6px"}
              shadow="none"
            >
              Accept
            </Button>
          </GridItem>
          <GridItem>
            <Button
              w={"171px"}
              h={"48px"}
              color="brand.white"
              bg="CRIMSON"
              colorScheme="brand.secondaryColor"
              borderRadius={"6px"}
              shadow="none"
            >
              Reject
            </Button>
          </GridItem>
        </Grid>
      </Box>
    </Box>
  );
};
